export default "__VITE_ASSET__CRecsvBS__"